export default __webpack_public_path__ + "static/media/visuals.bc5bd54b.jpeg";